import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Tooltip } from '@nextiva/engagement-ui';
import styles from './RichTextTool.scss';

class RichTextTool extends React.Component {
  static propTypes = {
    style: PropTypes.object,
    active: PropTypes.bool,
    onClick: PropTypes.func,
    iconClassName: PropTypes.string,
    className: PropTypes.string,
    activeClassName: PropTypes.string,
    children: PropTypes.node,
    tooltip: PropTypes.string,
  };

  handleMouseDown = e => {
    e.preventDefault();
    this.props.onClick();
  };

  render = () => {
    const {
      style,
      active,
      className,
      activeClassName,
      iconClassName,
      tooltip,
      children,
    } = this.props;

    return (
      <Tooltip text={tooltip}>
        <span
          style={style}
          className={cx(styles.tool, active ? activeClassName : className)}
          onMouseDown={this.handleMouseDown}
        >
          {iconClassName && <span className={cx(iconClassName)} />}
          {children}
        </span>
      </Tooltip>
    );
  };
}

export default RichTextTool;
